'use client';

import { Button } from '$components/Button';
import { Icon } from '$components/Icon';
import { ZeroElement } from '$components/ZeroElement';
import { LayoutContext } from '$root/src/context';
import cn from 'classnames';
import Link from 'next/link';
import React, { useContext, useEffect, useRef, useState } from 'react';

export default function NotFound() {
  const useLayoutStore = useContext(LayoutContext);
  const resized = useLayoutStore((state) => state.resized);
  const [newHeight, setHeight] = useState(0);
  const [classToUse, setClass] = useState('');

  const setHeights = () => {
    setHeight(window.innerWidth < 1024 ? 106 : 296);
    setClass(
      window.innerWidth < 1024 ? 'w-[116px] h-[116px]' : 'w-[306px] h-[306px]',
    );
  };

  useEffect(() => {
    setHeights();
  }, [resized]);

  const placeholder = {
    url: 'images/placeholder404.jpg',
  };

  return (
    <div className="my-32 lg:my-52 flex flex-row justify-center">
      <div className={`grid-standard `}>
        <div className={` col-span-4 lg:col-span-12`}>
          <div className="flex flex-row justify-center items-center mb-5 md:mb-8">
            <div className={cn('flex p-1 md:p-3')}>
              <svg
                //width="251"
                height={newHeight}
                viewBox="0 0 251 296"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 232.604H139.594V296H201.433V232.604H250.086V178.786H201.433V0H124.134L0 166.928V232.604ZM139.594 178.786H55.4737L139.594 65.6764V178.786Z"
                  fill="#0D0D0D"
                />
              </svg>
            </div>
            <div
              className={cn('flex relative p-1 md:p-3')}
              style={{ height: newHeight }}
            >
              <ZeroElement
                index={0}
                placeholderImage={placeholder}
                canPlayVideo={true}
                key={newHeight}
                truePosition={''}
                //autoHeight={false}
                assetType={'video'}
                type={'static'}
                imageAsset={null}
                videoAsset={
                  'https://player.vimeo.com/external/776679719.m3u8?s=a18cc03b729767107e6520dc086e818b1fe8664f'
                }
                customClass={classToUse}
              />
            </div>
            <div className={cn('flex p-1 md:p-3')}>
              <svg
                //width="251"
                height={newHeight}
                viewBox="0 0 251 296"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 232.604H139.594V296H201.433V232.604H250.086V178.786H201.433V0H124.134L0 166.928V232.604ZM139.594 178.786H55.4737L139.594 65.6764V178.786Z"
                  fill="#0D0D0D"
                />
              </svg>
            </div>
          </div>
          <div className={cn('flex flex-col justify-center items-center')}>
            <h2
              className={cn('text-center style-heading-xxs w-3/4 mb-5 md:mb-8')}
            >
              Unlike most vehicles, this page is incompatible with our fuel.
            </h2>
            <Link href={'/'}>
              <Button
                key={newHeight + '_'}
                action={null}
                size={newHeight === 296 ? 'large' : 'small'}
                iconRight={
                  <Icon
                    name={'arrowRight'}
                    fill={'fill-white group-hover:fill-white duration-300'}
                  />
                }
              >
                Travel here to go zero
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
